module.exports = __webpack_public_path__ + "img/ico_car.54e7d594.jpg";